export default "/fonts/vendor/mdui/dist/roboto/Roboto-LightItalic.woff?821fb0bb1ae8e8761798bc5a277b9ac3";